import { FreeCamera } from "@babylonjs/core/Cameras/freeCamera";
import { Color4 } from "@babylonjs/core/Maths/math.color";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import type { Scene } from "@babylonjs/core/scene";
import type { Disposable } from "@/shared/contracts/lifecycle";

export function createHoverIdleScene(scene: Scene): Disposable {
  scene.clearColor = new Color4(0, 0, 0, 0);

  const camera = new FreeCamera(
    "hover-idle-camera",
    new Vector3(0, 0, -1),
    scene,
  );
  camera.setTarget(new Vector3(0, 0, 0));
  camera.inputs.clear();
  camera.minZ = 0.1;
  scene.activeCamera = camera;

  return {
    dispose() {
      camera.dispose();
    },
  };
}
